import { toast as original } from 'sonner';
import { translateText } from './Locale';
export * from 'sonner';
const options = value => value && typeof value === 'object' ? { ...value, description: translateText(value.description) } : value;
export const toast = new Proxy(original, {
  apply(target, self, args) { return Reflect.apply(target,self,[translateText(args[0]),options(args[1])]); },
  get(target, property) {
    if (['success','error','info','warning','message','loading'].includes(property)) return (message, opts) => target[property](translateText(message),options(opts));
    return target[property];
  }
});